module.exports = __webpack_public_path__ + "img/bom3.6785c7c0.png";